'use client';

import { useEffect, useState, type ComponentType } from 'react';
import type { AdSlotProps } from './AdSlot';
import { isLabPerformanceAgent, whenThirdPartyAllowed } from '@/lib/defer-third-party';

type AdSlotWrapperProps = AdSlotProps;

/**
 * AdSlot mount olana kadar aynı yüksekliği rezerve eder; reklam geç
 * yüklendiğinde içerik aşağı itilmez (CLS). AdSlot mount olunca kendi
 * yükseklik/collapse mantığı devralır.
 */
const RESERVE_MIN_H: Record<'horizontal' | 'square' | 'vertical', number> = {
  horizontal: 90,
  square: 250,
  vertical: 250,
};

export default function AdSlotWrapper(props: AdSlotWrapperProps) {
  const [Slot, setSlot] = useState<ComponentType<AdSlotProps> | null>(null);

  useEffect(() => {
    if (isLabPerformanceAgent()) return;

    let cancelled = false;
    void whenThirdPartyAllowed({ fallbackMs: 3_500 })
      .then(() => import('./AdSlot'))
      .then((module) => {
        if (!cancelled) setSlot(() => module.AdSlot);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (!Slot) {
    return (
      <div
        aria-hidden
        style={{ minHeight: RESERVE_MIN_H[props.format ?? 'horizontal'] }}
      />
    );
  }
  return <Slot {...props} />;
}
